import type { SbEditableComponentProps } from "types/storyblok";
import { AutocompleteForm } from "modules/common/components";
import { AutocompleteFormTabs } from "modules/common/components/AutocompleteForm/experiment/AutocompleteFormTabs";
import { useOptimizely } from "hooks/useOptimizely";
import type { HeroFormProps } from "./HeroForm.d";
import { InfoCheckmarks } from "./InfoCheckmarks/InfoCheckmarks";
import { Uploader } from "./Uploader/Uploader";

export const HeroForm = ({
  ctaVariant = "primary",
  buttonText = undefined,
  checkmarks = [],
  hideCheckmarks = false,
  sbEditable,
  formVariant = "wide",
}: SbEditableComponentProps<HeroFormProps>) => {
  const { variationId } = useOptimizely({
    experimentName: "Multivariate test on Homepage",
    experimentId: 26528150322,
  });

  const heroFormExperimentVariationIds = [1083967682772931, 997174370478555, 8629836215200260, 1982834183995948];

  const renderForm = () => {
    if (heroFormExperimentVariationIds.includes(variationId)) return <AutocompleteFormTabs ctaVariant={ctaVariant} buttonText={buttonText} variant={formVariant} />;
    return (
      <AutocompleteForm
        ctaVariant={ctaVariant}
        buttonText={buttonText}
        sbEditable={sbEditable}
        variant={formVariant}
      />
    );
  };

  return (
    <>
      {renderForm()}
      <Uploader />
      {hideCheckmarks || <InfoCheckmarks checkmarks={checkmarks} />}
    </>
  );
};
